export default __webpack_public_path__ + "static/media/flexisafLogo.bb92f7de.svg";